import {
  Box,
  Container,
  Wrap,
  Text,
} from '@chakra-ui/react';
import CcdcCoverageIndicator from '@src/components/shared/CcdcCoverageIndicator';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import RoadConditionSealedRoads from './components/report-sections/RoadConditionSealedRoads';
import RoadConditionReportHeader from './components/report-headers/RoadConditionReportHeader';
import RoadConditionAmenitySealedRoads from './components/report-sections/RoadConditionAmenitySealedRoads';
import RoadConditionRoadRoughness from './components/report-sections/RoadConditionRoadRoughness';
import DataDisclaimer from '../../components/DataDisclaimer';
import RoadConditionRutting from './components/report-sections/RoadConditionRutting';
import RoadConditionTexture from './components/report-sections/RoadConditionTexture';

function RoadCondition() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Road Condition"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                This page provides reporting on the condition of the roads in this network.
              </Text>
              <Text mb={4}>
                Prior to 2024/25, Territorial Authorities were responsible for collecting their own condition data on their local roads.
              </Text>
              <Text mb={4}>
                Since 2024/25, road condition data has been collected nationally by the Consistent Condition Data Collection project for all Territorial Authorities except Chatham Islands.
              </Text>
              <Text mb={4}>
                NZTA collects State Highways condition data annually via Pavement condition surveys.
              </Text>
              <CcdcCoverageIndicator mb={4} />
            </>
          )}
        />
        <Box ref={printableRef}>
          <RoadConditionReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <RoadConditionAmenitySealedRoads />
            <RoadConditionRoadRoughness />
            <RoadConditionSealedRoads />
            <RoadConditionRutting />
            <RoadConditionTexture />
          </Wrap>
          <DataDisclaimer />
        </Box>
      </Container>
    </MainLayout>
  );
}

export default RoadCondition;
